import React from 'react';

const WidgetApp = () => {
	return (
		<div id="widget-app" className="widget-app container-fluid">
			WidgetApp
		</div>
	);
};

export default WidgetApp;
